import { Loader, Title } from "@sicredi/react";
import React from "react";

export default function LoadingPage() {
  return (
    <div
      style={{
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Title as="h1">Carregando</Title>
      <Loader show={true} fullScreen />
    </div>
  );
}
